import { Box } from "@mui/material";
import React, { useContext, useEffect } from "react";
import QuoteList from "../../../components/QuoteComponents/Quotelist";
import QuoteRouteHeader from "../../../components/QuoteComponents/QuoteRouteHeader";
import GetShippingQuote from "../../../components/QuoteComponents/GetShippingQuote";
import { getPostpalMarkups } from "../../../helper/functions";
import SidebarContext from "../../../context/SidebarContext";
import PageHeader from "../../../components/PageHeader";

export default function QuotePage() {
  // const { open } = useContext(SidebarContext);
  const [getShippingQuotes, setGetShippingQuotes] = React.useState([]);
  const [finalMarkups, setFinalMarkups] = React.useState({});
  const [formValues, setFormValues] = React.useState({});
  const [showQuote, setShowQuote] = React.useState(false);
  const getAllMarkups = async () => {
    const final = {}
    let markups = await getPostpalMarkups();
    console.log(markups,"markupsmarkupsmarkups");
    
    markups?.map((mark) => {final[mark?.id]= mark.quote_markup_rate})
    console.log(final,"finalfinal");
    
    setFinalMarkups(final)
  }

  useEffect(() => {
    getAllMarkups();
  }, [])
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        margin: { xs: "10px", sm: "15px", md: "20px" },
        marginRight: { xs: "10px", sm: "15px", md: "0px" },
        width: {
          xs: "calc(100vw - 20px)",
          sm: "calc(100vw - 30px)",
          md: "calc(98vw - 80px)",
        },
        backgroundColor: "#F7F7F7",
        borderRadius: "12px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: "15px", sm: "20px" },
          borderRadius: "12px",
        }}
      >
        <PageHeader pageTitle={"Shipping Quote"} />
      </Box>
      <Box>
        {showQuote ? (
          <QuoteList setGetShippingQuotes={setGetShippingQuotes} setShowQuote={setShowQuote} getShippingQuotes={getShippingQuotes} formValues={formValues}/>
        ) : (
          <GetShippingQuote setGetShippingQuotes={setGetShippingQuotes} setShowQuote={setShowQuote} finalMarkups={finalMarkups} setFormValues={setFormValues}/>
        )}
      </Box>
    </Box>
  );
}
